<template lang="pug">
    extends ../base/base.pug
    block input
        b-row
            b-col(md)
                div
                    = '{{ question }}'
                    span(
                    v-if="is_required"
                    class="requiredField"
                    ) *
            b-col(md)
                v-select(
                v-model="local_answer"
                @input="changed_answer()"
                :required="is_required"
                :state="get_state"
                :options="options"
                label="text"
                taggable
                )
                    div.spinner(slot="spinner" style="font-size: 11px;")
                        | Loading...
                b-form-invalid-feedback
                    = '{{ error_message }}'
                b-form-text
                    = '{{ helper }}'
</template>
<script>
import Base from "../base";
import VueSelect from "vue-select";

export default {
	extends: Base,
	components: {
		"v-select": VueSelect
	},
	computed: {
		options: {
			get() {
				return this.$store.state[this.slug].options;
			}
		}
	},
	methods: {
		changed_answer() {
			if (this.local_answer && !this.local_answer.value) {
				this.local_answer.value = this.local_answer.text;
			}

			this.process_change();
		}
	}
};
</script>
